import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

import VModal from 'vue-js-modal'

Vue.use(VueAxios, axios)
Vue.use(VueMaterial)
Vue.use(Donut)
Vue.use(VModal)

Vue.config.productionTip = false;

export const URLs = {
  app: 'https://ingress-backend.herokuapp.com/',
  proxy: 'https://cors-anywhere.herokuapp.com/'
}

new Vue({
  render: h => h(App),
}).$mount('#app')

/**       _____                       _____                       _____                       _____            
         /\    \                     /\    \                     /\    \                     /\    \           
        /::\____\                   /::\    \                   /::\____\                   /::\    \          
       /::::|   |                   \:::\    \                 /::::|   |                  /::::\    \         
      /:::::|   |                    \:::\    \               /:::::|   |                 /::::::\    \        
     /::::::|   |                     \:::\    \             /::::::|   |                /:::/\:::\    \       
    /:::/|::|   |                      \:::\    \           /:::/|::|   |               /:::/  \:::\    \      
   /:::/ |::|   |                      /::::\    \         /:::/ |::|   |              /:::/    \:::\    \     
  /:::/  |::|___|______       ____    /::::::\    \       /:::/  |::|   | _____       /:::/    / \:::\    \    
 /:::/   |::::::::\    \     /\   \  /:::/\:::\    \     /:::/   |::|   |/\    \     /:::/    /   \:::\ ___\ 
/:::/    |:::::::::\____\   /::\   \/:::/  \:::\____\   /:: /    |::|   /::\____\   /:::/____/  ___\:::|    |
\::/    / ~~~~~/:::/    /   \:::\  /:::/    \::/    /   \::/    /|::|  /:::/    /   \:::\    \ /\  /:::|____|
 \/____/      /:::/    /     \:::\/:::/    / \/____/     \/____/ |::| /:::/    /     \:::\    /::\ \::/    / 
             /:::/    /       \::::::/    /                      |::|/:::/    /       \:::\   \:::\ \/____/    
            /:::/    /         \::::/____/                       |::::::/    /         \:::\   \:::\____\      
           /:::/    /           \:::\    \                       |:::::/    /           \:::\  /:::/    /      
          /:::/    /             \:::\    \                      |::::/    /             \:::\/:::/    /       
         /:::/    /               \:::\    \                     /:::/    /               \::::::/    /        
        /:::/    /                 \:::\____\                   /:::/    /                 \::::/    /         
        \::/    /                   \::/    /                   \::/    /                   \::/____/          
         \/____/                     \/____/                     \/____/                                       


          _____                       _____                       _____                       _____          
         /\    \                     /\    \                     /\    \                     /\    \         
        /::\    \                   /::\    \                   /::\    \                   /::\    \        
       /::::\    \                 /::::\    \                 /::::\    \                 /::::\    \       
      /::::::\    \               /::::::\    \               /::::::\    \               /::::::\    \      
     /:::/\:::\    \             /:::/\:::\    \             /:::/\:::\    \             /:::/\:::\    \     
    /:::/__\:::\    \           /:::/__\:::\    \           /:::/__\:::\    \           /:::/__\:::\    \    
   /::::\   \:::\    \         /::::\   \:::\    \          \:::\   \:::\    \          \:::\   \:::\    \   
  /::::::\   \:::\    \       /::::::\   \:::\    \       ___\:::\   \:::\    \       ___\:::\   \:::\    \  
 /:::/\:::\   \:::\____\     /:::/\:::\   \:::\    \     /\   \:::\   \:::\    \     /\   \:::\   \:::\    \ 
/:::/  \:::\   \:::|    |   /:::/__\:::\   \:::\____\   /::\   \:::\   \:::\____\   /::\   \:::\   \:::\____\
\::/   |::::\  /:::|____|   \:::\   \:::\   \::/    /   \:::\   \:::\   \::/    /   \:::\   \:::\   \::/    /
 \/____|:::::\/:::/    /     \:::\   \:::\   \/____/     \:::\   \:::\   \/____/     \:::\   \:::\   \/____/ 
       |:::::::::/    /       \:::\   \:::\    \          \:::\   \:::\    \          \:::\   \:::\    \     
       |::|\::::/    /         \:::\   \:::\____\          \:::\   \:::\____\          \:::\   \:::\____\    
       |::| \::/____/           \:::\   \::/    /           \:::\  /:::/    /           \:::\  /:::/    /    
       |::|  ~|                  \:::\   \/____/             \:::\/:::/    /             \:::\/:::/    /     
       |::|   |                   \:::\    \                  \::::::/    /               \::::::/    /      
       \::|   |                    \:::\____\                  \::::/    /                 \::::/    /       
        \:|   |                     \::/    /                   \::/    /                   \::/    /        
         \|___|                      \/____/                     \/____/                     \/____/         
                                                                                                            
*/